import { TReduxActions } from '../../types/redux';
import {
  COMPLAIN_COMPLAINTS_FETCHED,
  COMPLAIN_COMPLAINT_SENDED,
  COMPLAIN_FAIL_REQUEST,
  COMPLAIN_REQUEST,
  COMPLAIN_CHANGE_VISIBILITY,
} from '../../constants/actionTypes/complain';
import { IComplain } from '../../types/complain';

const defaultState = {};

export function complainReducer(state: IComplain = defaultState, action: TReduxActions) {
  switch (action.type) {
    case COMPLAIN_REQUEST:
      return {
        ...state,
        [action.offerId]: {
          ...state[action.offerId],
          isLoading: true,
        },
      };

    case COMPLAIN_FAIL_REQUEST:
      return {
        ...state,
        [action.offerId]: {
          ...state[action.offerId],
          error: action.error,
        },
      };

    case COMPLAIN_COMPLAINTS_FETCHED:
      const { complaints } = action;

      return {
        ...state,
        [action.offerId]: {
          ...state[action.offerId],
          isLoading: false,
          complaints,
        },
      };

    case COMPLAIN_COMPLAINT_SENDED:
      const { complaintId, getUserFeedback } = action;

      return {
        ...state,
        [action.offerId]: {
          ...state[action.offerId],
          getUserFeedback,
          complaintId: Number(complaintId),
          isLoading: false,
          isSubmitted: true,
        },
      };

    case COMPLAIN_CHANGE_VISIBILITY:
      return {
        ...state,
        [action.offerId]: {
          isVisible: action.isVisible,
          complaints: [],
          isLoading: false,
          isSubmitted: false,
          getUserFeedback: false,
          complaintId: undefined,
        },
      };

    default:
      return state;
  }
}
